<template>
  <button :class="`ace-button--${variant}${textClass}${iconClass}`" @click="$emit('click')">
    <span class="ace-button__image" v-if="variant === 'image'">
      <img :srcset="`${images['1x']}, ${images['2x']} 2x`" :src="images['1x']" :alt="text" />
    </span>
    <span class="ace-button__text" v-if="text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    images: {},
    text: {},
    variant: {
      type: String,
      validators: value => ['light', 'dark', 'image'].includes(value),
    },
    icon: {
      type: String,
      validators: value => ['arrow', 'plus', 'cross'].includes(value),
    },
  },
  methods: {},
  computed: {
    iconClass() {
      return this.icon ? ` ace-button--icon ace-button--icon-${this.icon}` : ' ace-button-no-icon';
    },
    textClass() {
      return this.text ? ' ace-button--text' : '';
    },
  },

  created() {},
  beforeCompile() {},
  compiled() {},
  ready() {},
  attached() {},
  detached() {},
  beforeDestroy() {},
  destroyed() {},

  directives: {},
  elementDirectives: {},
  filters: {},
  components: {},
  transitions: {},
  partials: {},

  inherit: false,
  events: {},
  watch: {},
  mixins: [],
  name: '',
};
</script>

<style scoped lang="scss">
.ace-button {
  $this: &;

  cursor: pointer;
  transition: 300ms ease background;

  background: transparent;
  border: none;
  border-radius: 30px;

  height: 30px;
  width: 30px;

  display: block;

  font-size: 13px;
  font-weight: 700;
  &--grouped {
    width: 100%;
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;

    opacity: 0.5;
  }
  &--icon {
    &::before {
      color: #ffffff;

      display: inline-block;

      position: relative;

      font-family: FontAwesome;
    }
    &-arrow {
      &::before {
        content: '\f105';
      }
    }
    &-plus {
      &::before {
        content: '\FF0B';
      }
    }
    &-cross {
      &::before {
        content: '\2715';
      }
    }
  }

  &:hover:not([disabled]) {
    &::before {
      color: #ffffff;
    }
  }
  &--white {
    background: #ffffff;
    border: 2px solid #01a34a;
    color: #01a34a;

    @extend .ace-button;
    &::before {
      color: #01a34a;
    }

    &:hover:not([disabled]) {
      &::before {
        color: #01a34a;
      }
    }
  }
  &--dark {
    background: #01a34a;
    border-color: #ffffff;
    color: #ffffff;

    @extend .ace-button;

    &:hover:not([disabled]) {
      background: darken(#01a34a, 5%);
    }
  }
  &--light {
    background: #b3d234;
    border-color: #ffffff;
    color: #ffffff;

    @extend .ace-button;

    &:hover:not([disabled]) {
      background: darken(#b3d234, 5%);
    }
  }
  &--text {
    height: auto;
    padding: 10px 20px;
    width: auto;
    &::before {
      margin-right: 10px;
    }
  }
  &--image {
    cursor: pointer;

    background: #fafafa;
    border-radius: 10px;

    padding: 15px 60px;
    width: 100%;

    display: flex;
    flex-direction: column;

    @extend .ace-button;
    align-items: center;
    appearance: none;
    #{$this}__image {
      height: 125px;
      margin-bottom: 15px;

      display: block;
      display: flex;
      flex-direction: column;

      justify-content: flex-end;
    }
    #{$this}__text {
      font-size: 21px;
      line-height: 28px;
    }
  }
}
</style>
